import is from 'is_js';
import Immutable, { List } from 'immutable';
import Interval from 'domain/Interval';
import SessionPlan from './';

const reviver = ([key, val]) => {
  if (key === 'sessionMembers' && ! val) return [key, new List()];
  if (! val) return [key, val];
  switch (key) {
    case 'attendanceId':
    case 'id':
    case 'groupId':
    case 'unitId':
      return [key, `${val}`]; // stringify
    case 'unitIds':
      return [key, updateUnitIds(val)];
    case 'period':
      return [key, updatePeriod(val)];
    case 'sessionMembers':
      return [key, new List(val.map((v) => `${v}`))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

export const create = (data) =>
  new SessionPlan(data).mapEntries(reviver);

export default create;

function updateUnitIds(unitIds) {
  return Array.isArray(unitIds) ?
    unitIds.map((id) => `${id}`) :
    unitIds;
}

function updatePeriod(period) {
  if (is.undefined(period)) {
    return undefined;
  }

  return Interval.create(period);
}



// WEBPACK FOOTER //
// ./data/SessionPlans/model/create.js